import * as React from 'react';

import * as styles from './CommercialInfoReadyBusiness.css';
import { ICommercialInfoReadyBusinessProps } from './types';
import { CommercialIncome } from '../../../../../CommercialIncome';

export const CommercialInfoReadyBusiness: React.FC<ICommercialInfoReadyBusinessProps> = props => {
  const { income, currency, incomePeriod } = props;

  if (!income || currency == null) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <CommercialIncome income={income} currency={currency} incomePeriod={incomePeriod} />
    </div>
  );
};

CommercialInfoReadyBusiness.displayName = 'CommercialInfoReadyBusiness';
